import { Directive, Input, SimpleChanges, OnChanges } from '@angular/core';
import { Validator, AbstractControl } from '@angular/forms';
import { NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[appRequiredIf]',
  providers: [{ provide: NG_VALIDATORS, useExisting: RequiredIfDirective, multi: true }],
})
export class RequiredIfDirective implements Validator, OnChanges {
  @Input()
  appRequiredIf: boolean;

  private _onChange: () => void;

  validate(c: AbstractControl) {
    const value = c.value;
    if ((value === null || value === undefined || value === '') && this.appRequiredIf) {
      return {
        requiredIf: { condition: this.appRequiredIf },
      };
    }
    return null;
  }

  registerOnValidatorChange(fn: () => void): void {
    this._onChange = fn;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('appRequiredIf' in changes) {
      if (this._onChange) {
        this._onChange();
      }
    }
  }
}
